"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function convertToStepTimes(json) {
    var fps = json['fps'];
    if (json['keyframes'] != null) {
        var keyframes = json['keyframes'];
        return keyframes.map(function (x) { return x / fps; });
    }
    else {
        var steps = json['steps'];
        return steps.map(function (x) { return x['frame'] / fps; });
    }
}
exports.convertToStepTimes = convertToStepTimes;
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prezi/template-preview-lite/dist/helpers.js
// module id = 150
// module chunks = 0